import React, { useCallback, useMemo } from "react";

import { Banner as PlexBanner, BannerStatus } from "@plex/react-components";

import { AppError } from "infrastructure";
import { INotification } from "infrastructure/notification";
import { useLocalizerWithFallback } from "ui/hooks";

interface IBannerMessageProps {
  type: BannerStatus;
  data: INotification;
  index: number;
  removeAction: (messageIndex: number) => void;
  className?: string;
  shouldScroll?: (data: INotification) => boolean;
}

const getAppError = (error?: Error) => {
  if (error instanceof AppError) {
    return error;
  } else {
    return null;
  }
};

export const BannerMessage: React.FC<IBannerMessageProps> = ({ type, data, index, removeAction, className, shouldScroll }) => {
  const localize = useLocalizerWithFallback();

  const localizedTitle = useMemo(() => {
    return data.content.map((notification, i) => {
      const appError = getAppError(notification.error);

      return <p key={i}>{notification.message ? localize(notification.message) : appError != null ? localize(appError.message, appError.message) : notification.error?.message}</p>;
    });
  }, [data, localize]);

  const removeActionClick = useCallback(() => {
    removeAction(index);
  }, [index, removeAction]);

  return (
    <PlexBanner scroll={!shouldScroll || shouldScroll(data)} key={index} status={type} close={removeActionClick} className={className}>
      {localizedTitle}
    </PlexBanner>
  );
};
